import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportViewerModule } from 'ngx-ssrs-reportviewer';
import { LocalStorageService } from 'ngx-webstorage';
import { URLsConfig } from 'src/app/URLsConfig';

@Component({
  selector: 'app-report-vewier',
  templateUrl: './report-vewier.component.html',
  styleUrls: ['./report-vewier.component.css'],
})
export class ReportVewierComponent implements OnInit {
  private sub: any;
  reportServer: string = this.urlsconfig.WebReportsURL;
  //reportServer: string = 'http://desktop-se4svqd:81/ReportServer';
  //reportServer: string = 'http://192.168.1.198/ReportServer';
  reportUrl: string = '';
  showParameters: string = 'true';
  parameters: any = {};
  language: string = 'en-us';
  width: number = 100;
  height: number = 100;
  toolbar: string = 'true';
  submitClicked: any;

  constructor(
    public routeparams: ActivatedRoute,
    public storage: LocalStorageService,
    public urlsconfig: URLsConfig
  ) {
    let myPassedData: any = routeparams.params;
  }

  ngOnInit(): void {
    this.sub = this.routeparams.params.subscribe((params) => {

      ////--------------------* Patient number doctors care by service *-------------------
      if (params['ReportURL'] == 'CocReports/PatVisitsDoctor') {
        this.parameters = {FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), DocCode: this.storage.retrieve('stgPar3') };
      }
      ////--------------------* Patients By Nationality  *-------------------
      if (params['ReportURL'] == 'CocReports/PatByNationalty') {
        this.parameters = {FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2') };
      }
      ////--------------------* Patient number by every gender  *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_CancerType_Detailed') {
        this.parameters = {FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2') ,CancerID:this.storage.retrieve('stgPar3')};
      }

      ////--------------------* Patient number by every gender)Summary *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_CancerType_Month_Total') {
        this.parameters = {FromYear: this.storage.retrieve('stgParD1'), ToYear: this.storage.retrieve('stgParD2'),CancerType:this.storage.retrieve('stgPar3')};
      }
     ////--------------------* Number of patients by cancer type (details) *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_CancerType_Detailed') {
        this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2') ,CancerID:this.storage.retrieve('stgPar3')};
      }
      ////--------------------* Clinic patients Status *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_Status_Detailed') {
        this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2') ,CancerID:this.storage.retrieve('stgPar3')};
      }
      ////--------------------* Mortality Report *-------------------
      if (params['ReportURL'] == 'CocReports/PatientMortality') {
        this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2') ,CancerType:this.storage.retrieve('stgPar3'),Reason :this.storage.retrieve('stgPar4')};
      }

      ////--------------------* Patient List from Date To Date *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_ByDate_Detailed') {
        this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2')};
      }
      ////--------------------* Patient List from Date To Date By Cancer Type *-------------------
      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_CancerType_All') {
        this.parameters = {FromYear: this.storage.retrieve('stgPar1'), ToYear: this.storage.retrieve('stgPar2'),CancerType:this.storage.retrieve('stgPar3')};
      }
     ////--------------------* Patient List from Date To Date By Gov *-------------------
      if (params['ReportURL'] == 'CocReports/PatByGov') {
        this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2')};
      }

     ////--------------------* Patient List from Date To Date By Nationalty *-------------------
     if (params['ReportURL'] == 'CocReports/PatByNationalty') {
      this.parameters = {FromDate: this.storage.retrieve('stgPar1'), ToDate: this.storage.retrieve('stgPar2')};
    }

      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_CancerType_Detailed_All') {
        this.parameters = {FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2') ,CancerID:this.storage.retrieve('stgPar3')};
      }
      if (params['ReportURL'] == 'CocReports/PreparationOrder_D') {
        this.parameters = { PrepCode: this.storage.retrieve('stgPar') };
      }
      if (params['ReportURL'] == 'CocReports/TTTFollowUp') {
        this.parameters = { PaCode: this.storage.retrieve('stgPar') };
      }

      if (params['ReportURL'] == 'CocReports/PatintLis_Year_Graph') {
        this.parameters = { FromYear: this.storage.retrieve('stgPar1'), ToYear: this.storage.retrieve('stgPar2') };
      }
      if (params['ReportURL'] == 'CocReports/PatintLis_Gendr_CancerType') {
        this.parameters = { FromYear: this.storage.retrieve('stgPar1'), ToYear: this.storage.retrieve('stgPar2') };
      }
      if (params['ReportURL'] == 'CocReports/ExaminationDet') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), PatientCode: this.storage.retrieve('stgParD3') };
      }
       ///////----------* Reservation by Room *--------------------
      if (params['ReportURL'] == 'CocReports/ReservationByRoom') {
               this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), RoomNo: this.storage.retrieve('stgParD3') };
      }
    ///////----------* Reservation by Room Type*--------------------
      if  (params['ReportURL'] == 'CocReports/ReservationByRoomType') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), RoomType: this.storage.retrieve('stgParD3') };
      }
      if (params['ReportURL'] == 'CocReports/ReservationByDoctor') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), DoctorNo: this.storage.retrieve('stgParD3') };
      }

      if (params['ReportURL'] == 'CocReports/ReservationOA') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2') };
      }

      if (params['ReportURL'] == 'CocReports/ReservationByPatient') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), PatientID: this.storage.retrieve('stgParD3') };
      }


      //////============================================= Pharmathotical Reports =============================================
      if (params['ReportURL'] == 'CocReports/PreparationByPat') {
        this.parameters = { PatientCode: this.storage.retrieve('stgParD3') };
      }

      if (params['ReportURL'] == 'CocReports/NursingFollowUp') {
        this.parameters = {FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2')};
      }
      if (params['ReportURL'] == 'CocReports/PreparationByDate') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2') };
      }
      ////PreparationByProtocol
      if (params['ReportURL'] == 'CocReports/PreparationByProtocol') {
        this.parameters = { FromDate: this.storage.retrieve('stgParD1'), ToDate: this.storage.retrieve('stgParD2'), ProtocolCode: this.storage.retrieve('stgParProtocol') };
      }

      if (params['ReportURL'] == 'CocReports/FollowUpVisit') {
        this.parameters = { PatientCode: this.storage.retrieve('stgParD3') };
      }

  //////============================================= Pharmathotical Reports =============================================
  if (params['ReportURL'] == 'CocReports/PersonalData') {
    this.parameters = { PatientCode: this.storage.retrieve('stgPar') };
  }
  if (params['ReportURL'] == 'CocReports/Prescription' || params['ReportURL'] == 'CocReports/ReqLab' || params['ReportURL'] == 'CocReports/ReqScan') {
    this.parameters = { PatientCode: this.storage.retrieve('stgPar'),CMDate: this.storage.retrieve('stgDate') };
  }

  if (params['ReportURL'] == 'CocReports/Discharge_Medications') {
    this.parameters = {DocNumber: this.storage.retrieve('stgPar')};
  }


  if (params['ReportURL'] == 'CocReports/SavingByPatient') {
    this.parameters = { PatientCode: this.storage.retrieve('stgParD3'),FDate: this.storage.retrieve('stgParD1'), TDate: this.storage.retrieve('stgParD2')};
  }

  if (params['ReportURL'] == 'CocReports/SavingByDrug') {
    this.parameters = {FDate: this.storage.retrieve('stgParD1'), TDate: this.storage.retrieve('stgParD2')};
  }
  //////============================================= Accounting Reports =============================================
  if (params['ReportURL'] == 'CocReports/Expensses') {
    this.parameters = { Serial: this.storage.retrieve('stgPar'),company: this.storage.retrieve('stgPar1') };
  }
  if (params['ReportURL'] == 'CocReports/Revenue') {
    this.parameters = { Serial: this.storage.retrieve('stgPar'),company: this.storage.retrieve('stgPar1') };
  }
  //////////=================== Expenses ===============================
  if (params['ReportURL'] == 'CocReports/ExpenssesReport1' ||params['ReportURL'] == 'CocReports/RevenueReport1') {
    this.parameters = { Bank: this.storage.retrieve('stgBank'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/ExpenssesSupplier') {
    this.parameters = { Supplier: this.storage.retrieve('stgSupplier'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/ExpenssesSupplierT' || params['ReportURL'] == 'CocReports/ExpenssesClassT')  {
    this.parameters = { FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/ExpenssesClass') {
    this.parameters = {Class: this.storage.retrieve('stgClass'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenuePatient') {
    this.parameters = { Patient: this.storage.retrieve('stgPatient'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenuePatientT') {
    this.parameters = {FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenueClass') {
    this.parameters = { Class: this.storage.retrieve('stgClass'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenueClassT' || params['ReportURL'] == 'CocReports/RevenueHospitalT' || params['ReportURL'] == 'CocReports/RevenueDoctorT') {
    this.parameters = {FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenueHospital') {
    this.parameters = {Hospital: this.storage.retrieve('stgHospital'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/RevenueDoctor') {
    this.parameters = {Doctor: this.storage.retrieve('stgDoctor'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/Safe_Bank_Transactions') {
    this.parameters = {Bank: this.storage.retrieve('stgBank'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }

  if (params['ReportURL'] == 'CocReports/Safe_Bank_TransactionsT') {
    this.parameters = {Bank: this.storage.retrieve('stgBank'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/PatientAcc' ||params['ReportURL'] == 'CocReports/PatientAccT') {
    this.parameters = {Patient: this.storage.retrieve('stgPatient'),compcode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/Invoice') {
    this.parameters = {Serial: this.storage.retrieve('stgSerial'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/Sales' || params['ReportURL'] == 'CocReports/SalesDiscounts' ||params['ReportURL'] == 'CocReports/SalesItems') {
    this.parameters = {FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/SalesItemsT') {
    this.parameters = {Item : this.storage.retrieve('stgItem'), FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/SalesPatient') {
    this.parameters = {FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'),Patient: this.storage.retrieve('stgPatient'), CompCode: this.storage.retrieve('stgCompCode')};
  }
  //////////=================== Stock Control ===============================
  if (params['ReportURL'] == 'CocReports/ItemBalances' || params['ReportURL'] == 'CocReports/ItemBalancesD') {
    this.parameters = {Class: this.storage.retrieve('stgClass'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'), CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/ItemCard' ) {
    this.parameters = {Store: this.storage.retrieve('stgStore'),ItemCode: this.storage.retrieve('stgItem'),FromDate: this.storage.retrieve('stgFromDate'),ToDate: this.storage.retrieve('stgToDate'), CompCode: this.storage.retrieve('stgCompCode')};
  }
  if (params['ReportURL'] == 'CocReports/ItemCost' || params['ReportURL'] == 'CocReports/ItemSales' || params['ReportURL'] == 'CocReports/ItemOrder') {
    this.parameters = {Class: this.storage.retrieve('stgClass'), CompCode: this.storage.retrieve('stgCompCode')};
  }
debugger;
      this.reportUrl = params['ReportURL']; // (+) converts string 'id' to a number
      console.log("this.reportUrl:",this.reportUrl)

    });
  }


}
